import { css } from 'linaria';

export const akinatorCompletionsPreloaderWrap = css`
  display: flex;
  gap: var(--space-100);
  width: 100%;
  padding: var(--space-100) var(--space-200);
`;
